import React from 'react';
import { Hero } from '../components/Hero';
import { Problem } from '../components/Problem';
import { QuoteMarquee } from '../components/QuoteMarquee';
import { HowItWorks } from '../components/HowItWorks';
import { Features } from '../components/Features';
import { ChatShowcase } from '../components/ChatShowcase';
import { Privacy } from '../components/Privacy';
import { UseCases } from '../components/UseCases';
import { FAQ } from '../components/FAQ';
import { FinalCTA } from '../components/FinalCTA';
export function Home() {
  return <>
      <Hero data-id="element-368" />
      <Problem data-id="element-369" />
      <QuoteMarquee data-id="element-370" />
      <HowItWorks data-id="element-371" />
      <Features data-id="element-372" />
      <ChatShowcase data-id="element-373" />
      <Privacy data-id="element-374" />
      <UseCases data-id="element-375" />
      <FAQ data-id="element-376" />
      <FinalCTA data-id="element-377" />
    </>;
}